import React from "react";
import { Space } from "antd";
import { AxDivider, AxIconWrapper, AxButton } from "@dynata/axiom3";

class DividerEx extends React.Component {
  render() {
    return (
      <div className="section" id="divider">
        <h3>Divider</h3>
        <p>A divider line separates different content.</p>

        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>

        <Space size="large" direction="vertical">
          <pre>{`<AxDivider />`}</pre>

          <div className="prop-header">
            <p className="props-title">Props</p>
            <p>
              For AntD props, visit{" "}
              <AxButton
                size="small"
                type="link"
                target="_blank"
                href="https://ant.design/components/divider/#API"
              >
                https://ant.design/components/divider/#API
              </AxButton>
            </p>
          </div>

          <table className="props-table">
            <thead>
              <tr>
                <th>Property</th>
                <th>Description</th>
                <th>Type</th>
                <th>Default</th>
                <th>Version</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>hoverable</td>

                <td>Whether the compontent is hoverable</td>
                <td>boolean</td>
                <td>-</td>
                <td>-</td>
              </tr>

              <tr>
                <td>dashed</td>

                <td>Whether line is dashed</td>
                <td>boolean</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>plain</td>

                <td>Divider text show as plain style; default is, true</td>
                <td>boolean</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>orientation</td>
                <td>
                  The position of title inside divider; default is, center
                </td>
                <td>left | center | right</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>children</td>
                <td>The wrapped title</td>
                <td>ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>className</td>
                <td>The className of container</td>
                <td>string</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>dashed</td>
                <td>Whether line is dashed</td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>plain</td>
                <td>Divider text show as plain style</td>
                <td>boolean</td>
                <td>true</td>
                <td>4.2.0</td>
              </tr>
              <tr>
                <td>style</td>
                <td>The style object of container</td>
                <td>CSSProperties</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>type</td>
                <td>The direction type of divider</td>
                <td>
                  <code>horizontal</code> | <code>vertical</code>
                </td>
                <td>
                  <code>horizontal</code>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>...others</td>
                <td>
                  All extra props are passed down to the{" "}
                  <>
                    <AxButton
                      size="small"
                      type="link"
                      target="_blank"
                      href="https://4x.ant.design/components/divider/#API"
                    >
                      {`<Divider />`}
                    </AxButton>
                  </>{" "}
                  component.
                </td>
                <td></td>
                <td>-</td>
                <td></td>
              </tr>              
            </tbody>
          </table>

          <AxDivider orientation="left" plain>
            All Variations
          </AxDivider>

          <Space size="large" direction="vertical">
            <pre>{`
<AxDivider hoverable />
<AxDivider dashed hoverable />
<AxDivider plain hoverable>
  <AxIconWrapper type="regular" size="10" icon={"fa-star"} /> Hover
</AxDivider>
<AxDivider plain hoverable>
  <AxIconWrapper type="regular" size="10" icon={"fa-star"} />
</AxDivider>            
<AxDivider />
<AxDivider dashed />
<AxDivider plain>Plain</AxDivider>
<AxDivider dashed plain>
  Plain
</AxDivider>
<AxDivider orientation="left" plain>
  Plain Left
</AxDivider>
<AxDivider orientation="right" plain>
  Plain Right
</AxDivider>

<AxDivider>Title</AxDivider>
<AxDivider dashed>Divider Title Dashed</AxDivider>
<AxDivider orientation="right">Right Label</AxDivider>
<AxDivider orientation="center">Center Label</AxDivider>
<AxDivider orientation="left" plain>Left Label</AxDivider>`}</pre>
            <Space size={40} direction="vertical">
              <AxDivider hoverable />
              <AxDivider dashed hoverable />
              <AxDivider plain hoverable>
                <AxIconWrapper type="regular" size="10" icon={"fa-star"} />{" "}
                Hover
              </AxDivider>

              <AxDivider plain hoverable>
                <AxIconWrapper type="regular" size="10" icon={"fa-star"} />
              </AxDivider>
              <AxDivider />
              <AxDivider dashed />
              <AxDivider plain>Plain</AxDivider>
              <AxDivider dashed plain>
                Plain
              </AxDivider>
              <AxDivider orientation="left" plain>
                Plain Left
              </AxDivider>
              <AxDivider orientation="right" plain>
                Plain Right
              </AxDivider>

              <AxDivider>Title</AxDivider>
              <AxDivider dashed>Divider Title Dashed</AxDivider>
              <AxDivider orientation="right">Right Label</AxDivider>
              <AxDivider orientation="center">Center Label</AxDivider>
              <AxDivider orientation="left" plain>
                Left Label
              </AxDivider>
            </Space>
          </Space>
        </Space>
      </div>
    );
  }
}
export default DividerEx;
